'use client';

import { useEffect, useState } from 'react';
import { useParams } from 'next/navigation';
import SiteHeader from '@/components/SiteHeader';
import Card from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import { apiClient } from '@/lib/api';

export default function NicknameRedirectPage() {
  const params = useParams();
  const raw = String((params as any)?.nickname || '').trim();
  const nickname = raw.startsWith('@') ? raw.slice(1) : raw;

  const [msg, setMsg] = useState<string>('Загрузка профиля...');

  useEffect(() => {
    if (!nickname) {
      setMsg('Некорректная ссылка');
      return;
    }
    let alive = true;
    (async () => {
      try {
        // Комментарий на русском: находим пользователя по никнейму и ведём на существующую страницу /users/{id}
        // (минимум нового UI-кода, приватность/логика профиля уже в /users/[id]).
        const res = await apiClient.request<any>(`/api/users/by-nickname/${encodeURIComponent(nickname)}/`);
        const id = Number(res?.id || 0) | 0;
        if (!alive) return;
        if (id > 0) {
          window.location.replace(`/users/${id}`);
          return;
        }
        setMsg('Профиль не найден');
      } catch (e: any) {
        if (!alive) return;
        setMsg(e?.message || 'Профиль не найден');
      }
    })();
    return () => {
      alive = false;
    };
  }, [nickname]);

  return (
    <div className="min-h-screen text-site-text relative overflow-hidden">

      <SiteHeader profileBrand />
      <div className="relative z-10 max-w-3xl mx-auto px-6 py-10">
        <Card className="p-6">
          <div className="text-site-text break-words">{msg}</div>
          <div className="mt-4">
            <Button variant="outline" onClick={() => window.location.assign('/')}>
              На главную
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}

